import React, { useState } from "react";

/**
 * Email Registration Modal Component
 * 
 * A reusable modal component for collecting user emails for registration/notification
 * 
 * @param {boolean} show - Whether the modal is visible
 * @param {function} onClose - Function to call when closing the modal
 */
const EmailRegistrationModal = ({ show, onClose }) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setMessage("Please enter a valid email address.");
      return;
    }

    setIsSubmitting(true);
    setMessage(""); // Reset message state

    try {
      const response = await fetch(
        "https://registeremail-qx4xtmce5q-uc.a.run.app", // Backend API
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      if (response.ok) {
        setMessage("Thank you! We'll notify you when we launch.");
        setEmail("");
      } else {
        const errorResult = await response.json();
        setMessage(errorResult.error || "Failed to register email.");
      }
    } catch (error) {
      console.error("Error submitting email:", error);
      setMessage("Something went wrong. Please try again later.");
    }

    setIsSubmitting(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
      style={{ zIndex: 9999 }}
      aria-labelledby="modal-title"
      aria-modal="true"
      role="dialog"
    >
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-2xl font-bold mb-4 text-center" id="modal-title">
          Be the First to Know!
        </h2>
        <p className="text-gray-600 mb-4 text-center">
          Enter your email, and we'll notify you when we launch.
        </p>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded mb-4"
        />
        <div className="flex justify-end space-x-4">
          <button
            className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-[#FF8C00] text-white rounded hover:bg-[#FF8C00]/90"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </div>
        {message && (
          <p className="mt-4 text-center text-gray-700">{message}</p>
        )}
      </div>
    </div>
  );
};

export default EmailRegistrationModal;
